import { FETCH_LIST_ITEMS as fetchListitems } from "../../../../../graphql/query/ListItems";
import { SelectList } from "../../../../../components/Functional";
import { useNavigate } from "react-router-dom";
import { LIST_TYPES } from "../../../../../constants/listTypes";

const Actions = props => {
  const { listId, workingListId } = props || {};
  const navigate = useNavigate();

  return (
    <div className="grid grid-flow-col gap-4">
      <SelectList.RemoveSelected {...props} listId={listId || workingListId} />
      <SelectList.ClearList {...props} listId={listId || workingListId} />
      {listId ? (
        <SelectList.ExitEditMode
          onSuccess={() => (
            props?.onSuccess?.(), navigate("/companies?status=selectListSaved")
          )}
        />
      ) : (
        <SelectList.SaveList
          {...{
            ...props,
            typeId: LIST_TYPES.COMPANY,
            onSuccess: () => (
              props?.onSuccess?.(),
              navigate("/companies?status=selectListSaved")
            ),
          }}
        />
      )}
    </div>
  );
};

const tableProps = props => {
  const { listId, workingListId } = props || {};
  // Prioritize listId (saved list) over workingListId (working list)
  const finalListId = listId || workingListId;

  const tableProps = {
    dataKey: "listItems",
    FETCH_QUERY: fetchListitems({
      item: { contact: {}, country: {} },
    }),
    fetchPolicy: "network-only",
    skip: () => !finalListId,
    variables: {
      listId: finalListId,
    },
  };

  return tableProps;
};

export { Actions, tableProps };
